module.exports = __webpack_public_path__ + "media/images/icons/flags/BG-a0f9a2cf2f99f12b1c3decb88ded1413.svg";